import { css } from 'styled-components';
import variables from './variables';
import light from './light';
import dark from './dark';

const themes = {
  light,
  dark,
};

export default css`
  ${variables}

  ${({ theme }) => themes[theme]};
`;
